import { Injectable } from '@angular/core'

import { PkwDatastore } from '../../../pkw-data/pkw-datastore'
import { ExtratoDeRecebimentos } from '../../../pkw-data/collect/extrato/extrato-de-recebimentos.model'
import { Pagina, ListaPaginada } from '../../../pkw-data/core/util/lista-paginada.model'

@Injectable()
export class ExtratoDeRecebimentosService {
    constructor(private pkwDatastore: PkwDatastore) {}

    obter(id: string) {
        return this.pkwDatastore.findRecord(ExtratoDeRecebimentos, id)
    }

    pesquisar(filtro: any, indicePagina?: number, tamanhoPagina?: number) {
        const pagina = new Pagina(indicePagina, tamanhoPagina)

        return this.pesquisarPaginado(filtro, pagina)
    }

    pesquisarPaginado(filtro: any, pagina: Pagina) {
        const params = {
            filter: filtro,
            page: pagina.toLimitOffset()
        }

        return this.pkwDatastore
            .findAll(ExtratoDeRecebimentos, params)
            .map(
                reponse =>
                    new ListaPaginada<ExtratoDeRecebimentos>(
                        reponse.getModels(),
                        pagina.indice,
                        pagina.tamanho,
                        reponse.getMeta().meta.totalResourceCount
                    )
            )
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-recebimentos/shared/extrato-de-recebimentos.service.ts